<template>
  <v-skeleton-loader
    v-if="request.lvConnectionAgreementUpdate.dataEntered === false"
    :loading="loading"
    :types="skeleton"
    type="article"
    class="mb-6"
    height="266"
  >
    <v-card class="px-9 py-7">
      <v-card-title class="pa-0">
        Odečty
      </v-card-title>
      <ValidationObserver ref="agreementNNRequestForm" v-slot="{ passes }">
        <v-form rel="agreementNNRequestForm" @submit.prevent="passes(save)">
          <v-row>
            <v-col cols="6" md="4" class="pb-1">
              <VTextFieldWithValidation
                :rules="{
                  numeric: true,
                  required: false,
                  min_value: oldReadingHighTariff,
                }"
                v-model="readingHighTariff"
                v-mask="'#######'"
                outlined
                label="Vysoký tarif"
                dense
              />
            </v-col>
            <v-col cols="6" md="8" class="pl-0 pb-1 pt-5">
              Poslední stav elektroměru (VT): {{ oldReadingHighTariff }} kWh
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="6" md="4" class="pb-1">
              <VTextFieldWithValidation
                :rules="{
                  numeric: true,
                  required: false,
                  min_value: oldReadingLowTariff,
                }"
                v-model="readingLowTariff"
                v-mask="'#######'"
                outlined
                label="Nízký tarif"
                dense
              />
            </v-col>
            <v-col cols="6" md="8" class="pl-0 pb-1 pt-5">
              Poslední stav elektroměru (NT): {{ oldReadingLowTariff }} kWh
            </v-col>
          </v-row>
          <v-card-title class="px-0">
            Přílohy
          </v-card-title>
          <v-row>
            <v-col cols="12" md="4" class="pt-0 pb-1">
              <VFileInputWithValidation
                v-model="attachment1"
                :rules="{
                  required: false,
                  ext: ['pdf'],
                  size: 10240,
                }"
                prepend-icon=""
                append-icon="$file"
                @click:append="
                  $event.target.offsetParent.querySelector(`[class='v-file-input__text']`).click()
                "
                :clearable="false"
                outlined
                dense
                label="Nahrajte soubor .PDF"
                accept=".pdf"
                @change="fileUpload($event)"
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="4" class="pt-0 pb-1">
              <VFileInputWithValidation
                v-model="attachment2"
                :rules="{
                  required: false,
                  ext: ['pdf'],
                  size: 10240,
                }"
                prepend-icon=""
                append-icon="$file"
                @click:append="
                  $event.target.offsetParent.querySelector(`[class='v-file-input__text']`).click()
                "
                :clearable="false"
                outlined
                dense
                label="Nahrajte soubor .PDF"
                accept=".pdf"
                @change="fileUpload($event)"
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="4" class="pt-0 pb-1">
              <VFileInputWithValidation
                v-model="attachment3"
                :rules="{
                  required: false,
                  ext: ['pdf'],
                  size: 10240,
                }"
                prepend-icon=""
                append-icon="$file"
                @click:append="
                  $event.target.offsetParent.querySelector(`[class='v-file-input__text']`).click()
                "
                :clearable="false"
                outlined
                dense
                label="Nahrajte soubor .PDF"
                accept=".pdf"
                @change="fileUpload($event)"
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="4" class="pt-0 pb-1">
              <VFileInputWithValidation
                v-model="attachment4"
                :rules="{
                  required: false,
                  ext: ['pdf'],
                  size: 10240,
                }"
                prepend-icon=""
                append-icon="$file"
                @click:append="
                  $event.target.offsetParent.querySelector(`[class='v-file-input__text']`).click()
                "
                :clearable="false"
                outlined
                dense
                label="Nahrajte soubor .PDF"
                accept=".pdf"
                @change="fileUpload($event)"
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="auto" class="mr-auto pt-0 pb-1">
              <v-btn
                depressed
                type="submit"
                height="40px"
                min-width="125px"
                color="primary"
                :loading="loading"
              >
                Uložit
              </v-btn>
            </v-col>
          </v-row>
        </v-form>
      </ValidationObserver>
    </v-card>
  </v-skeleton-loader>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  name: 'AgreementNNRequestForm',
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    request: {
      type: Object,
      required: true,
    },
  },
  components: {
  },
  data() {
    return {
      skeleton: {
        article: 'heading, paragraph@2',
      },
      colors: {
        actual: '#c6d8f0',
        new: '#fff',
        cantEdit: '#d8d8d8',
      },
      readingHighTariff: null,
      oldReadingHighTariff: null,
      readingLowTariff: null,
      oldReadingLowTariff: null,
      attachment1: null,
      attachment2: null,
      attachment3: null,
      attachment4: null,
    };
  },
  methods: {
    ...mapActions({
      sendLVAgreementSubrequestUpdate: 'requests/sendLVAgreementSubrequestUpdate',
      getInstallation: 'installations/getInstallation',
    }),
    save() {
      this.loading = true;
      const requestData = {
        id: this.$route.params.id,
        updateDto: {
          lowTariff: this.readingLowTariff,
          highTariff: this.readingHighTariff,
        },
        attachment1: this.attachment1,
        attachment2: this.attachment2,
        attachment3: this.attachment3,
        attachment4: this.attachment4,
      };
      this.sendLVAgreementSubrequestUpdate(requestData)
        .then((response) => {
          this.request.lvConnectionAgreementUpdate.dataEntered = response
            .data.lvConnectionAgreementUpdate.dataEntered;
          this.request.lvConnectionAgreementUpdate.attachments = response
            .data.lvConnectionAgreementUpdate.attachments;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    fileUpload(event) {
      this.file = event;
    },
  },
  created() {
    const params = {
      ean: this.request.ean,
    };
    if (this.request.lvConnectionAgreementUpdate.dataEntered === false) {
      this.getInstallation(params).then((response) => {
        this.oldReadingHighTariff = response.data.lastReadingHighTariff;
        this.oldReadingLowTariff = response.data.lastReadingLowTariff;
      });
    }
  },
};
</script>
